export default {
	Language: '한국어',
	system: {
		homePage: {
			title1: '标题1',
			title2: '标题2',
			description1: '近7日',
			description2: '近6个月',
		}
	},
	login:{
		register:'회원가입',
		usernamePls:'아이디를 입력해주세요',
		passwordPls:'비밀번호를 입력해주세요',
		toRegister:'계정이 없나요? 지금 회원가입하세요',
		doLogin:'로그인',	  
	},
	register:{
		repasswordPls:'출금 비밀번호를 입력하세요',  
		codePls:'초대코드를 입력해주세요',  
		register:'등록',
		xieyi:'이용약관 동의합니다',
		xieyiPls:'아래 계좌 개설 협의를 선택하세요!',
	},
	mine:{
		xyfs:'신용점수',
		ljjf:'누적 적립포인트',
		recharge:'포인트 충전',
		withdraw:'포인트 출금',
		money:'보유 포인트',
		infomation:'기본 정보',
		moneylog:'포인트 사용내역',
		withdrawrecord:'출금내역',
		gamerecord:'선물기록',
		notice:'공지사항',
		mymove:'시청기록',
		loginpwd:'로그인 비밀번호',
		paypwd:'비밀번호 사용',
		loginout:'로그아웃',
		paypwdhasseted:'현금 인출 비밀번호가 설정되었습니다. 수정이 필요하면 고객센터에 연락하십시오.',
		setbank:'수금 카드를 설정하세요!',
		lorr:'로그인 / 등록',
	},
	infomation:{
		username:'회원아이디',
		name:'성명',
		bankcard:'출금계좌',
		phone:'휴대폰번호',
		recharge:'충전',
		amount:'보유포인트',
		toserve:'고객 서비스에 문의하세요',
		kfms:'오프라인에서 충전을 원하시면 고객센터로 문의해주세요. 일부 결제채널의 충전금액은 소수점 1자리까지 랜덤으로 충전되오니 결제시꼭 확인해주세요',
	},
	withdraw:{
		title:'포인트 교환',
		log:'출금 기록',
		method:'출금방법',
		avmoney:'사용 가능포인트',
		limit:'출금한도',
		submit:'포인트 출금신청',
		xiane:'단일 한도액',
		numbers:'현금 인출 횟수',
		time:'입금 시간',
		zuidi:'최소',
		zuigao:'최고',
		numsmax:'하루 최대 현금 인출',
		ci:'횟수',
		timedetail:'보통 입금 시간은 5분 정도이고, 빠르면 2분 안에 입금됩니다.',
		bank:'은행 카드',
		status1:'보류 중',
		status2:'출금 완료',
		status3:'출금불가',
		enterCorrectAmount: '정확한 금액을 기입해 주십시오.',
		selectBankCard: '현금인출 은행카드를 선택하세요',
		enterPayPassword: '결제 비밀번호를 입력하십시오.',
		withdrawClosedNotice: '출금은 접수 담당자에게 문의하세요. 출금은 일반적으로 10-60분 내에 처리됩니다. 실제 입금 시간은 각 국가의 은행에 따라 다릅니다.',
		contactReception: '접수 담당자에게 문의하세요',
	},
	moneylog:{
		title:'포인트 세부정보',
		type1:'충전',
		type2:'채금',
		type3:'작업',
		type4:'보너스',
		type5:'출금완료',
		type6:'출금 실패',
		type7:'인증 심사 환불',
		rechargeNote: '（충전）',
	},
	setting:{
		loginpwdtitle:'로그인 비밀번호 변경',
		oldpwd:'이전 비밀번호를 입력하세요',
		newpwd:'새 비밀번호를 입력하세요',
		renewpwd:'새 비밀번호를 다시 입력하세요',
		change:'변경하기',
		plseall:'입력한 암호가 일치하지 않습니다!',
		pswwrong:'암호 입력이 두 번 일치하지 않음',
		paypwdtitle:'자금 암호 설정',
		paypwd:'출금계좌 비밀번호를 입력하세요',
		repaypwd:'비밀번호를 다시 한 번 확인해 주세요',
		title: '설정',
		basicInfo: '기본 정보 설정',
		loginPassword: '로그인 비밀번호',
		fundPassword: '자금 비밀번호',
		logout: '로그아웃',
		payPasswordSet: '출금 비밀번호가 설정되었습니다. 수정이 필요하면 고객센터에 연락하십시오',
		payPasswordNotSet: '설정되지 않음',
		payPasswordHasSet: '설정됨',
		confirm: '확인',
	},
	home:{
		gonggao:'궁극의 럭셔리 경험을 즐겨보세요',
		qgkf:'전국가능',
		hotlist:'인기 추천목록',
		hotgame:'창 활성화',
		gaoji:'고급',
		smrz:'실사인증',
		videorz:'본인영상인증',
		star:'별점',
		sg:'신장',
		xw:'사이즈',
		diqu:'서비스가능지역',
		apply:'데이트 신청하기',
		ssxz:'실시간 현황',
		joinvip:'님이 회원 가입하였습니다',
	},
	video:{
		title:'영상관',
		nums:'조희수',
		bofangliang:'조희수',
		hotlist:'인기 추천',
		plsrefisrt:'충전 후 동영상을 보십시오!',
	},
	choose:{
		title:'최고의 하루밤',
		nav:'프로필',
		apply:'매칭 신청',
		jianjie:'매니저 프로필',
		move:'이동가능여부',
		click:'인증하려면 클릭하세요',
		detail:'상세정보',
		videodetail:'라이브 비디오',
	},
	common:{
		refresh:'새로 고침 성공',
		noallow:'기능이 비활성화되었습니다!',
		disable:'비활성화',
		all:'전체',
		nomore:'더 이상 없어요.',
		nodata:'데이터 없음',
		submit:'제출',
		more:'매니저 더보기',
		pinglunnav:'이용후기',
		pingluntitle:'매니저 후기',
		pldtitle:'댓글 세부정보',
		minenav:'내 계정',
		homenav:'홈',
		addbank:'수금 카드 추가',
		setbank:'출금 계좌 등록',
		info:'정보',
		video:'비디오',
		square:'광장',
		auth:'인증',
		my:'내',
	},
	game:{
		expect:'기수',
		jieguo:'데이터',
		da:'대',
		xiao:'소',
		dan:'홀',
		shuang:'짝',
		大:'A',
		小:'B',
		单:'C',
		双:'D',
		order:'작업 명세서',
		clear:'주문 비우기',
		submit:'제출 확인',
		kjcc:'당첨 성공, 기호:',
		lxgly:'이 작업은 관리자에게 문의하십시오.',
		plsmoney:'금액을 기입해 주세요!',
		plsnum:'번호를 선택하세요!',
		moneynote:'잔액이 부족하니 고객센터에 연락하여 충전하세요!',
		lefttime:'남은시간',
		lunci:'회차',
		workRecord: '작업 기록',
		day: '일',
		period: '기간',
		allWork: '모든 작업',
		reset: '리셋',
		confirm: '확인',
		bonusPoints: '보너스 포인트',
		missionMoney: '작업 금액 상세',
		missionResult: '작업 결과',
		points: '포인트',
		workPoints: '작업 포인트',
		giftCompleted: '선물 완료',
		orderTime: '주문 시간:',
		detail: '상세',
		content: '내용',
		amount: '금액',
		result: '결과',
		time: '시간',
		win: '승리',
		missionFailed: '작업 실패',
	},
	kefu:{
		title:'온라인 고객센터',
		lianxi:'연락',
		content:'온종일 7 * 24시간 성심성의껏 서비스해드립니다',
		defaultName: '오소리 오락',
	},
	setname:{
		title:'실명 수정',
		xingming:'이름',
		tips:'귀하의 계좌 안전을 위해 실제 이름은 바인딩 은행 카드 이름과 일치해야 합니다',
		xmpls:'실명을 입력하십시오',
		save:'저장',
		notreset:'설정을 반복하지 마십시오!',
		plsentername:'이름을 입력하십시오!',
	},
	// 추가된 언어키
	withdrawCenter: '출금 센터',
	withdrawRecord: '출금 기록',
	withdrawAmount: '출금 금액',
	allMoney: '전체',
	singleLimit: '단일 한도',
	lowest: '최저',
	highest: '최고',
	withdrawTimes: '출금 횟수',
	maxDailyWithdraw: '하루 최고 출금',
	times: '회',
	arrivalTime: '입금 시간',
	limitDescription: '한도 설명',
	balance: '잔액',
	withdrawNow: '지금 출금',
	enterCorrectAmount: '올바른 금액을 입력하세요',
	personalReport: '개인 보고서',
	profitAmount: '수익 금액',
	profitFormula: '수익 계산 공식: 당첨 금액 - 작업 금액',
	taskAmount: '작업 금액',
	accountOffline: '계정 오프라인',
	loginRegister: '로그인/등록',
	loginForMore: '로그인하여 더 많은 서비스를 즐기세요!',
	// 评论相关
	author: '글쓴이:',
	notification: '알림',
	// 设置相关
	changePhone: '휴대폰번호 변경',
	save: '저장',
	existingPhone: '기존 휴대전화번호',
	newPhone: '새 휴대전화번호',
	// 银行相关
	withdrawAccountRegister: '출금 계좌 등록',
	selectBankCard: '은행카드를 선택해주세요',
	accountNumber: '계좌번호',
	enterBankCardNumber: '은행 카드 번호를 입력하세요',
	// 通知相关
	systemNotice: '시스템 공지',
	// 观看记录相关
	myMovie: '내 영화',
	completeTaskForMore: '더 많은 영화표를 받으려면 작업을 완료하세요',
	movieTicket: '영화 릴:',
	watchList: '시청목록',
	noDataYet: '아직 데이터가 없습니다',
	// 其他
	setNameFirst: '성함 설정 후 출금계좌 연동부탁드립니다！',
	setPasswordFirst: '현금인출 비밀번호를 설정한 후에 은행카드를 묶으세요!',
	// 银行相关
	accountHolder: '예금주',
	enterRealName: '실명을 입력해주세요',
	withdrawPassword: '출금 비밀번호',
	registerWithdrawPassword: '출금 비밀번호 등록하실',
	bankCard: '은행 카드',
	// 游戏相关
	orderContentLabel: '주문 내용:',
	all: '모두',
	bonusPointsLabel: '보너스 포인트',
	waitingResultLabel: '결과 대기중',
	missionMoneyDetails: '미션금 내역',
	points: '점',
	// 彩票相关
	switch: '스위치',
	currentSelection: '현재 선택:',
	quantity: '수량:',
	total: '총',
	ticketAmount: '티켓 양',
	availablePoints: '사용 가능한 포인트',
	verify: '인증하기',
	// 个人资料相关
	possible: '가능',
	thumb: '엄지손가락',
	privacyPolicy: '보안방침',
	romanticDescription: '저희 로맨틱은 회원님의 개인정보 보호를위해 본인인증서비스를 통해 인증완료 또는 인증이완료된 회원들의 추천을 통해서 가입이 가능합니다.',
	// 首页相关
	person1: '하율',
	person2: '민설',
	// 详情页相关
	profile: {
		productDetail: '상품 상세',
		beautyDetail: '미인 상세',
		nickname: '닉네임',
		type: '유형',
		serviceProject: '서비스 항목',
		views: '조회수',
		likes: '좋아요 수',
		bookNow: '지금 예약',
		warmTip: '안내',
		contactService: '고객 서비스에 문의하여 예약 기능을 활성화하세요.',
		gotIt: '알겠습니다',
		activateVisible: '활성화하여 보기',
		missingParams: '필수 매개변수 누락',
		orderUnderReview: '검토 중인 주문이 있습니다. 고객 서비스 검토가 완료될 때까지 기다려주세요',
		createOrderFailed: '주문 생성 실패',
		createOrderFailedRetry: '주문 생성 실패, 나중에 다시 시도하세요',
	},
	// 认证相关
	certification: {
		certOrderNo: '인증 주문 번호 (3분마다 자동 업데이트)',
		record: '기록',
		certSuccess: '인증 성공! 공개 주문 번호: {orderNo}, 차감 {deducted} 포인트, 현재 잔액: {balance} 포인트',
		timeRemaining: '주문 유효기간 남음',
		refreshing: '새로고침 중...',
		enterPoints: '포인트를 입력하세요',
		selectedItems: '선택한 항목: {count}개',
		estimatedDeduct: '예상 총 차감: {amount} 포인트',
		currentBalance: '현재 계정 잔액',
		points: '포인트',
		confirmCert: '인증 확인',
		currentProgress: '현재 인증 진행 상황',
		needComplete: '{count}개의 주문 작업을 더 완료해야 합니다',
		waitingSettlement: '결제 대기 중...',
		completed: '완료됨',
		myCertRecords: '내 인증 기록',
		totalRecords: '(총 {count}개)',
		carCert: '차비 인증',
		hotelCert: '호텔 인증',
		confidentialCert: '기밀 인증',
		approved: '승인됨',
		pendingReview: '검토 대기',
		items: '항목',
		orderNo: '주문 번호',
		pointsConsumed: '소비된 포인트',
		applyTime: '신청 시간',
		reviewTime: '검토 시간',
		noRecords: '기록 없음',
		getRecordsFailed: '기록 가져오기 실패',
		getRecordsFailedRetry: '기록 가져오기 실패, 나중에 다시 시도하세요',
		selectCertType: '인증 유형 선택',
		officialData: '공식 협력 데이터',
		onlineMatch: '온라인 매칭',
		nextStep: '다음: 항목 선택',
		selectCertTypeByProgress: '주문 진행 상황에 따라 인증 유형을 선택하세요',
		pleaseSelectCertType: '인증 유형을 선택하세요',
		missingBeautyId: '미인 ID 매개변수 누락',
		getDataFailed: '데이터 가져오기 실패',
		getLotteryFailed: '복권 정보 가져오기 실패, 나중에 다시 시도하세요',
		betFailed: '베팅 실패',
		betFailedRetry: '베팅 실패, 나중에 다시 시도하세요',
		none: '없음',
		product1: '상품1',
		product2: '상품2',
		product3: '상품3',
		product4: '상품4',
	},
};
